import { Subject, BehaviorSubject } from 'rxjs';
import { ScreenRoute } from '../../constants/ScreenRouteConstant';

const dashboardBehaviorSubject = new Subject();
export const dashboardBehavior = {
    setData: (data: any = null) => {
        dashboardBehaviorSubject.next({ data: data });
    },
    clear: () => dashboardBehaviorSubject.next(null),
    getObservable: () => dashboardBehaviorSubject.asObservable()
};

const userDetailsSubject = new Subject();
export const userDetailsSubscription = {
    setUserDetails: (familyData: any = null) => {
        userDetailsSubject.next(familyData)
    },
    clearPopUp: () => userDetailsSubject.next(),
    getUserDetails: () => userDetailsSubject.asObservable()
}

const familyDetailsSubject = new Subject();
export const familyDetailsSubscription = {
    setFamilyDetails: (familyData: any = null) => {
        familyDetailsSubject.next(familyData)
    },
    clearPopUp: () => familyDetailsSubject.next(),
    getFamilyDetails: () => familyDetailsSubject.asObservable()
}


const popUpOnClickOkSubject = new Subject();
export const popUpOnClickOkSubscription = {
    setpopUpOnClickOk: (OnClickOk: any = false) => {
        console.log('rk caling ');

        popUpOnClickOkSubject.next(OnClickOk)
    },
    clearPopUp: () => popUpOnClickOkSubject.next(),
    getpopUpOnClickOk: () => popUpOnClickOkSubject.asObservable()
}

const paymentServiceNameSubject = new BehaviorSubject(false);
export const paymentServiceNameSubscription = {
    setPaymentServiceName: (serviceName: any) => {
        paymentServiceNameSubject.next(serviceName); console.log('serviceName data', serviceName);
    },
    getPaymentServiceName: () => paymentServiceNameSubject.asObservable()
}

const selectedAayuCardForPurcahseSubject = new BehaviorSubject({});
export const selectedAayuCardForPurcahseSubscription = {
    setSelectedAayuCard: (value: any) => {
        selectedAayuCardForPurcahseSubject.next(value);
    },
    getSelectedAayuCard: () => selectedAayuCardForPurcahseSubject.asObservable()
}

const selectedLocationSubject = new BehaviorSubject({});
export const selectedLocationForDashboard = {
    setSelectedLocation: (locationData: any) => {
        selectedLocationSubject.next(locationData);
    },
    getSelectedLocation: () => selectedLocationSubject.asObservable()
}

const WebSocketMessageSubject = new BehaviorSubject({});
export const WebSocketMessageSubscription = {
    setWebSocketMessage: (value: any) => {
        console.log('setWebSocketMessage value', value);

        WebSocketMessageSubject.next(value);
    },
    getWebSocketMessage: () => WebSocketMessageSubject.asObservable()
}

export const OMSOrderDataSubject = new BehaviorSubject({});
export const OMSOrderDataSubscription = {
    clearOmsOrderData: () => OMSOrderDataSubject.next({}),
    getomsOrderData: () => OMSOrderDataSubject.asObservable(),
    setomsOrderData: (value: any) => { OMSOrderDataSubject.next(value) }
}

const ActivtyDataSubject = new BehaviorSubject({});
export const activtyDataSubscription = {
    setActivityData: (value: any) => {
        ActivtyDataSubject.next(value);
    },
    getActiviytData: () => ActivtyDataSubject.asObservable()
}

const OrderListSubject = new BehaviorSubject([]);
export const orderListSubscriptionForOrderSummary = {
    clearOrderList: () => OrderListSubject.next([]),
    getOrderList: () => OrderListSubject.asObservable(),
    setOrderList: (value: any) => OrderListSubject.next(value),
}

const ConsultationListSubject = new BehaviorSubject([]);
export const consultationListSubscriptionForConsultationDetails = {
    setConsultList: (value: any) => {
        ConsultationListSubject.next(value);
    },
    getConsultList: () => ConsultationListSubject.asObservable()
}

const UserSavedAddress = new BehaviorSubject({});
export const UserSavedAddressSubscription = {
    clearSavedAddress: () => UserSavedAddress.next({}),
    getSavedAddress: () => UserSavedAddress.asObservable(),
    setSavedAddress: (value: any) => UserSavedAddress.next(value),
}

const deeplinkData = new BehaviorSubject({})
export const DeeplinkDataSubscription = {
    setDeeplinkData: (value: any) => {
        deeplinkData.next(value);
    },
    getDeeplinkData: () => deeplinkData.asObservable()
}

const updateAuthToken = new BehaviorSubject({})
export const UpdateAuthToken = {
    setAuthToken: (value: any) => {
        updateAuthToken.next(value);
    },
    getAuthToken: () => updateAuthToken.asObservable()
}

const chemistStoreTab = new BehaviorSubject(ScreenRoute.home)
export const ActiveTabControler = {
    setActiveTab: (value: any) => {
        chemistStoreTab.next(value);
    },
    getActiveTab: () => chemistStoreTab.asObservable()
}

const screenPushBackData = new BehaviorSubject({})
export const ScreenPushBackData = {
    clearPushBackData: () => screenPushBackData.next({}),
    getPushBackData: () => screenPushBackData.asObservable(),
    setData: (value: any) => { screenPushBackData.next(value) },
}

const refeshWebData$ = new BehaviorSubject([])
export const CacheDataToRefresh = {
    setRefreshList: (value: any) => {
        refeshWebData$.next(value);
    },
    getDataToRefresh: () => refeshWebData$.asObservable()
}

export const cartProducts$ = new BehaviorSubject([]);
export const productsAndDeals$ = new BehaviorSubject([]);
export const openQuantityModal$ = new BehaviorSubject(false);
export const updatedProduct$ = new BehaviorSubject({});
export const selectedStore$ = new BehaviorSubject({});
export const StoreBuzyCallModel$ = new BehaviorSubject(false);

export const commonModalData$ = new BehaviorSubject({
    active: false
});
export const backpressBheaviour$ = new BehaviorSubject({
    backpress: false, backpressData: {}
});









